import React from 'react';

import { AGENT_PERMISSION_MEDIA_LIBRARY, useIsSubscriptionAllowed } from 'hooks/useIsSubscriptionAllowed';
import { BlockerForAgent } from 'hooks/useSubscriptionBlockContent';
import useTheme from 'hooks/useTheme';
import { MEDIA_MIME_TYPES } from 'utils/asset';

import { ACCOUNT_TYPE_AGENT } from '../../../../constants';
import FileLibrary from '../Common';

const MediaLibrary = () => {
  useTheme('danger');

  const isAllowed = useIsSubscriptionAllowed(ACCOUNT_TYPE_AGENT, AGENT_PERMISSION_MEDIA_LIBRARY);

  return (
    <>
      {!isAllowed && <BlockerForAgent />}

      <FileLibrary
        allowedMimeTypes={MEDIA_MIME_TYPES}
        title="Media Library"
        buttonText="Upload Media"
        createTitle="Add New Media"
        updateTitle="Manage Media"
        tagsSubTitle="Add some keywords to make it easy to find and categorize your image."
        namePlaceholder="Elephant Family"
        tagsPlaceholder="Elephant"
        placeholder="No Media Files Found"
        module="media"
      />
    </>
  );
};

export default MediaLibrary;
